import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollRestoration = () => {
  const { pathname } = useLocation();

  window.history.scrollRestoration = "manual";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};

export default useScrollRestoration;
